import React, { useState, useRef, useEffect } from 'react'
import { navigate } from 'gatsby'

import * as Styled from './styles/SearchMenu.styles'
import { ArrowInCircle } from '../Icons'
import { NAV_MENU_STATUS } from '../../util/constants'

const CtaButton = () => (
  <Styled.SearchButtonContainer as="button" type="submit">
    <Styled.SearchButtonText>Search</Styled.SearchButtonText>
    <ArrowInCircle />
  </Styled.SearchButtonContainer>
)

const SearchMenu = ({ isSearchMenuOpen, setNavMenuStatus }) => {
  const [searchText, setSearchText] = useState('')
  const inputRef = useRef(null)

  const submitForm = e => {
    e.preventDefault()
    navigate(`/search-results/?q=${encodeURI(searchText)}`)
    setNavMenuStatus(NAV_MENU_STATUS.CLOSED)
  }
  useEffect(() => {
    if (isSearchMenuOpen) {
      inputRef.current.focus()
    }
  }, [isSearchMenuOpen])

  return (
    <Styled.SearchForm onSubmit={submitForm}>
      <Styled.SearchField
        ref={inputRef}
        onChange={e => setSearchText(e.target.value)}
        placeholder="Enter search terms"
      />
      <CtaButton />
    </Styled.SearchForm>
  )
}

export default SearchMenu
